import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../../../../environments/environmet';
import { ApiResponse } from '../../../companies/data/models/company.models';
import { SalesReportsResponse } from '../models/sales-reports.models';

@Injectable({
  providedIn: 'root'
})
export class SalesReportsApiService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = environment.apiBaseUrl;

  getSalesReports(params: any): Observable<ApiResponse<SalesReportsResponse>> {
    let httpParams = new HttpParams();
    if (params.companyId) httpParams = httpParams.set('companyId', params.companyId.toString());
    if (params.pageNumber) httpParams = httpParams.set('pageNumber', params.pageNumber.toString());
    if (params.pageSize) httpParams = httpParams.set('pageSize', params.pageSize.toString());
    if (params.search) httpParams = httpParams.set('search', params.search);
    if (params.fromDate) httpParams = httpParams.set('fromDate', params.fromDate);
    if (params.toDate) httpParams = httpParams.set('toDate', params.toDate);
    if (params.status) httpParams = httpParams.set('status', params.status);
    if (params.paymentStatus) httpParams = httpParams.set('paymentStatus', params.paymentStatus);

    return this.http.get<ApiResponse<SalesReportsResponse>>(`${this.baseUrl}/reports/sales`, { params: httpParams });
  }
}